export const REQUEST_ACCOUNT = "REQUEST_ACCOUNT";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const REQUEST_UPDATE_ACCOUNT = "REQUEST_UPDATE_ACCOUNT";
export const SUCCESS_UPDATE_ACCOUNT = "SUCCESS_UPDATE_ACCOUNT";
export const ERROR_UPDATE_ACCOUNT = "ERROR_UPDATE_ACCOUNT";
